import { render, staticRenderFns } from "./MA335Mobile.vue?vue&type=template&id=be3f46f4&scoped=true&"
import script from "./MA335Mobile.vue?vue&type=script&lang=js&"
export * from "./MA335Mobile.vue?vue&type=script&lang=js&"
import style0 from "./MA335Mobile.vue?vue&type=style&index=0&id=be3f46f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3f46f4",
  null
  
)

export default component.exports